import { Theme } from '@mui/material';
import { CommonComponents } from '../types';

export function getMuiPickersDay(theme: Theme): CommonComponents {
  return {
    styleOverrides: {
      root: {
        borderRadius: theme.shape.borderRadiusMd,
        '&:hover': {
          borderRadius: theme.shape.borderRadiusMd,
        },
      },
    },
  };
}
